import React, { useEffect, useState } from 'react';
const INITIAL_COPIES = 236;
const MIN_COPIES = 30;
const STORAGE_KEY = 'bttf_copies_available';
export const CopiesAvailableCounter = () => {
  const [copiesAvailable, setCopiesAvailable] = useState(() => {
    if (typeof window === 'undefined') return INITIAL_COPIES;
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : INITIAL_COPIES;
  });
  useEffect(() => {
    // Initialize localStorage if not set
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      localStorage.setItem(STORAGE_KEY, INITIAL_COPIES.toString());
    }
    const decrementCopies = () => {
      setCopiesAvailable(prev => {
        // Don't go below MIN_COPIES to maintain urgency
        if (prev <= MIN_COPIES) return prev;
        // Decrease by 1 copy only (slower decrease)
        const decrease = 1;
        const newValue = Math.max(MIN_COPIES, prev - decrease);
        // Store in localStorage
        localStorage.setItem(STORAGE_KEY, newValue.toString());
        // Dispatch custom event for synchronization
        window.dispatchEvent(new CustomEvent('copiesUpdated', {
          detail: newValue
        }));
        return newValue;
      });
    };
    // Listen for updates from other components
    const handleCopiesUpdate = (event: CustomEvent) => {
      setCopiesAvailable(event.detail);
    };
    window.addEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
    // Listen for storage changes from other tabs
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        setCopiesAvailable(parseInt(e.newValue, 10));
      }
    };
    window.addEventListener('storage', handleStorageChange);
    // Moderate interval between 6-9 seconds
    const getRandomInterval = () => Math.floor(Math.random() * 3000) + 6000;
    let timeoutId: NodeJS.Timeout;
    const scheduleNextDecrement = () => {
      timeoutId = setTimeout(() => {
        decrementCopies();
        scheduleNextDecrement();
      }, getRandomInterval());
    };
    scheduleNextDecrement();
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  return <div className="w-auto inline-flex flex-col items-center gap-1 bg-gradient-to-r from-red-600 to-orange-600 text-white font-bold px-3 py-1.5 md:px-5 md:py-2 rounded-md shadow-md animate-pulse" data-id="element-134">
      <div className="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-0.5" data-id="element-135">
        <span className="text-xs md:text-sm lg:text-base tabular-nums font-extrabold tracking-wide" data-id="element-136">
          LIMITED 1985 COPIES RELEASE
        </span>
      </div>
    </div>;
};